export default __webpack_public_path__ + "8a82d329ad83b746bc4afe37d4e2aadc.png";